module.exports = __webpack_public_path__ + "img/final_reg.e189af3f.svg";